import { Alert, AlertDescription } from '@monksflow/monks-ui';
import { EyeIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function BriefTemplateReadOnlyNotice() {
  const { t } = useTranslation('knowledge');

  return (
    <Alert data-testid="brief-template-read-only-notice">
      <EyeIcon aria-hidden className="size-4" />
      <AlertDescription>{t('knowledgeHub.briefTemplateBuilder.readOnlyNotice')}</AlertDescription>
    </Alert>
  );
}
